// colors used on the website
// colors used on the website

const colors = {
  primary: '#669900',
  primaryInverted: '#9966ff',
  secondary: '#000',
  tertiary: '#fff',
  darkBrown: '#666600',
  zircon: '#EDF0F1',
  gray: '#808080',
  warning: '#B00020',
  light: '#f8f9fa',
  lightOpacity: 'rgba(248, 249, 250, 0.9)',

 // night mode colors
  darkNavy: '#020c1b',
  navy: '#0a192f',
  lightNavy: '#112240',
  lightestNavy: '#233554',
  lightestNavyOpacity: 'rgba(35, 53, 84, 0.9)',
  darkSlate: '#495670',
  slate: '#8892b0',
  lightSlate: '#a8b2d1',
  lightestSlate: '#ccd6f6',
  lightGreen: '#64ffda',
  chromeBlue: '#3297FD',
}

export default colors



